import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { IOfferLine } from '~shared/modules/cart/models';
import { EcommerceApplicationEventPayload } from '~shared/models';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';

export class RemoveItemFromCartApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.RemoveItemFromCart;

  constructor(private cartOfferLine: IOfferLine) {}

  getPayload(): EcommerceApplicationEventPayload {
    return {
      ecommerce: {
        items: GaTrackingCheckoutService.getItemsForApplicationEvent([this.cartOfferLine]),
      },
    };
  }
}
